import React from "react";

import {
  faCheck,
  faExclamationCircle,
} from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";

import { setSetting } from "actions";

import { FaIcon } from "components/AgGridButtonIcon/agGridButtonIcon";
import Clickable from "components/Button/Clickable";

import { AttachmentSearchFields } from "constants/attachmentSearch";
import { Settings } from "constants/settings";

import { openAttachments, openEditConsignmentModal } from "lib/navigation";

export function NVDRecRenderer({ value, data }) {
  const dispatch = useDispatch();

  if (!data) {
    return null;
  }

  // Handle salelots and consignments aggrids
  const { consignment = data } = data;
  const hasNoExceptions = value !== false && !consignment.hasNVDExceptions;

  return (
    <Clickable
      onClick={() => {
        dispatch(
          setSetting(Settings.attachmentSearch, {
            [AttachmentSearchFields.Consignment]: [consignment.id],
          }),
        );
        openAttachments();
      }}
    >
      <FaIcon
        icon={hasNoExceptions ? faCheck : faExclamationCircle}
        color={hasNoExceptions ? "success" : "warning"}
      />
    </Clickable>
  );
}

export function NVDRenderer(props) {
  if (!props.data) {
    return null;
  }
  const { value } = props;
  if (value) {
    return value;
  } else {
    return <FaIcon icon={faExclamationCircle} color="warning" />;
  }
}

export function NVDIDRenderer(props) {
  const { value, data } = props;

  if (!data) {
    return null;
  }

  let consignmentId = null;

  if (data.consignment) {
    consignmentId = data.consignment.id;
  } else {
    consignmentId = data.id;
  }

  function onClickEdit() {
    if (consignmentId) {
      openEditConsignmentModal(consignmentId, undefined, true);
    }
  }

  if (value) {
    return value;
  } else {
    return (
      <FaIcon
        icon={faExclamationCircle}
        color="warning"
        onClick={onClickEdit}
        style={{ cursor: "pointer" }}
      />
    );
  }
}
